import React, { useEffect, useState } from 'react';

import LatestResultsApi from 'Api/SiteApi/LatestResultsApi';

export function BetsSection({ lotteryDrawId }: { lotteryDrawId: number }) {
    const [sportBets, setSportBets] = useState([]);

    useEffect(() => {
        LatestResultsApi.getSportBetsResults(lotteryDrawId).then((data) => {
            setSportBets(data);
        });
    }, []);

    function getDetails() {
        return (
            <div className="d-flex flex-row mt-5">
                <div className="row no-gutters">
                    <div className="row row-match" key="match-line">
                        {sportBets[0].bets.map((match, matchIndex) => (
                            <p key={`match-${matchIndex}`} className="pr-5">
                                {matchIndex + 1}. {match.competitors[0].name} - {match.competitors[1].name}:{' '}
                                <strong>{Object.values(match.bet).join(matchIndex >= 14 ? '-' : ',')}</strong>
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return sportBets.length && sportBets[0].bets.length > 0 ? getDetails() : null;
}
